import React from 'react';
import useScrollReveal from '../hooks/useScrollReveal';

const testimonials = [
  {
    name: 'Rajesh Sharma',
    location: 'NAINA Plot Investor',
    text: 'Prime Acres made the entire land investment process seamless and transparent. Their expertise on the NAINA region was invaluable, and our plot has shown incredible appreciation potential.',
    rating: 5,
  },
  {
    name: 'Priya Deshmukh',
    location: 'KSC New Town Investor',
    text: 'What impressed us most was the end-to-end support — from plot selection to registration. The team was highly professional and guided us through every legal step with complete transparency.',
    rating: 5,
  },
  {
    name: 'Amit Kulkarni',
    location: 'MahaMumbai Plot Buyer',
    text: 'Investing with Prime Acres near the upcoming NMIA airport was the best financial decision we made. Their market foresight and curated plot selection are truly unmatched. Highly recommended!',
    rating: 5,
  },
];

const trustBadges = [
  { value: '500+', label: 'Happy Investors' },
  { value: '4.8/5', label: 'Google Rating' },
  { value: '10+', label: 'Years Experience' },
  { value: '15+', label: 'Expert Team' },
];

const Testimonials = () => {
  const [headRef, headVisible] = useScrollReveal();
  const [cardsRef, cardsVisible] = useScrollReveal({ threshold: 0.1 });
  const [badgeRef, badgeVisible] = useScrollReveal({ threshold: 0.2 });

  return (
    <section className="py-24 lg:py-32 relative overflow-hidden bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        {/* Header — left aligned */}
        <div ref={headRef} className={`grid lg:grid-cols-2 gap-10 lg:gap-20 mb-16 transition-all duration-700 ${headVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div>
            <span className="inline-block text-[11px] tracking-[0.3em] uppercase font-semibold text-accent-500 mb-5">
              Client Stories
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading text-dark-800 leading-tight">
              What Our Clients{' '}
              <span className="italic text-primary-600">Say</span>
            </h2>
          </div>
          <div className="flex items-end">
            <p className="text-dark-400 text-base leading-relaxed font-light">
              Real stories from real investors who trusted Prime Acres with their land investment.
            </p>
          </div>
        </div>

        {/* Testimonial Cards — staggered */}
        <div ref={cardsRef} className="grid md:grid-cols-3 gap-5 mb-16">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className={`bg-gray-50 rounded-2xl p-8 border border-transparent hover:border-primary-100 hover:bg-primary-50/30 transition-all duration-700 relative group ${
                cardsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: cardsVisible ? `${i * 150}ms` : '0ms' }}
            >
              {/* Quote */}
              <span className="text-5xl font-heading text-primary-100 leading-none select-none absolute top-4 right-6 group-hover:text-accent-200 transition-colors duration-500">"</span>

              {/* Stars */}
              <div className="flex gap-1 mb-5">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <svg key={j} className="w-4 h-4 text-accent-400" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>

              <p className="text-dark-500 text-[14px] leading-relaxed font-light mb-8 relative z-10">
                "{t.text}"
              </p>

              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-primary-600 flex items-center justify-center text-white font-heading text-sm">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <p className="text-sm font-medium text-dark-700">{t.name}</p>
                  <p className="text-[11px] text-dark-300 font-light">{t.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Badges — inline row */}
        <div ref={badgeRef} className={`flex flex-wrap items-center justify-center gap-8 sm:gap-12 lg:gap-16 py-8 border-t border-gray-100 transition-all duration-700 ${badgeVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          {trustBadges.map((badge, i) => (
            <div key={i} className="text-center group">
              <p className="text-2xl md:text-3xl font-heading text-primary-600 mb-1 group-hover:text-accent-500 transition-colors duration-500">
                {badge.value}
              </p>
              <p className="text-[10px] text-dark-400 tracking-[0.15em] uppercase font-medium">{badge.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
